import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  stagCodeSelector,
  getStagForCode,
  getCodeForStag,
  setSelectedStag,
  deregisterStagListeners,
  fetchData,
  clearSpecialCount,
  homepageLoadingSelector,
  homepageTitleSelector,
  stagExistsSelector,
  userIsAdminForStag,
  selectedStagSelector,
  networkStatusSelector,
  hasStagDataSelector,
  joinStag,
  userHasJoinedStagSelector,
} from '../../../reducers';
import Stag from './component';

const mapStateToProps = (state) => {
  return {
    code: stagCodeSelector(state) || '',
    exists: stagExistsSelector(state) ? true : false,
    hasStagData: hasStagDataSelector(state) ? true : false,
    adminVisible: userIsAdminForStag(state, selectedStagSelector(state)) ? true : false,
    loading: homepageLoadingSelector(state) ? true : false,
    siteTitle: homepageTitleSelector(state),
    networkStatus: networkStatusSelector(state),
    userHasJoinedStag: userHasJoinedStagSelector(state) ? true : false,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getStagForCode,
    getCodeForStag,
    setSelectedStag,
    deregisterStagListeners,
    fetchData,
    clearSpecialCount,
    joinStag,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Stag);



// WEBPACK FOOTER //
// ./src/component/organisms/Stag/index.js